"use client";
import React from "react";

export type UploadContextType = {
  uploadUrl: string;
  downloadUrl: string;
  uploadEnabled: boolean;
};

const UploadContext = React.createContext<UploadContextType | null>(null);

export const UploadProvider = ({
  children,
  uploadUrl,
  downloadUrl,
}: {
  children: React.ReactNode;
  uploadUrl: string;
  downloadUrl: string;
}) => {
  const providerEnabled = uploadUrl !== "" && downloadUrl !== "";
  return (
    <UploadContext.Provider
      value={{
        downloadUrl,
        uploadUrl,
        uploadEnabled: providerEnabled,
      }}
    >
      {children}
    </UploadContext.Provider>
  );
};

export const useUploadConfig = () => {
  const ctx = React.useContext(UploadContext);
  if (!ctx) throw new Error("UploadProvider missing");
  return ctx;
};
